import React from "react";

const modules = [
  {
    icon: "🎯",
    name: "DirectorEnrollment",
    text: "Start your digital journey.",
  },
  { icon: "📍", name: "FindItLocal", text: "Discover and grow local." },
  { icon: "🎁", name: "StreakGifts", text: "Build streaks. Earn rewards." },
  { icon: "🚀", name: "Hustlers", text: "Find gigs. Create income." },
  { icon: "💼", name: "MiniERP", text: "Run your business smarter." },
  { icon: "🏆", name: "SAKSHAM MSME Kit", text: "Assess. Improve. Grow." },
  { icon: "👩‍💼", name: "FoundHer", text: "Build and lead your venture." },
  { icon: "🛒", name: "HerKart", text: "Sell online. Start COD." },
];

const flywheel = [
  { icon: "🔍", title: "DISCOVER", text: "Find opportunities around you." },
  { icon: "🧠", title: "LEARN", text: "Build digital skills and confidence." },
  { icon: "💰", title: "EARN", text: "Start creating digital income." },
  { icon: "🚀", title: "BUILD", text: "Turn ideas into businesses." },
  { icon: "🛒", title: "SELL", text: "Reach customers and markets." },
  { icon: "📈", title: "GROW", text: "Scale your income and business." },
  { icon: "🤝", title: "EMPOWER", text: "Help others grow with you." },
];

export default function GenZUdaan() {
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="mx-auto w-full max-w-7xl">
        {/* Hero Banner */}
        <section className="px-3 pt-3 sm:px-5 sm:pt-5">
          <div className="flex flex-col">
            <div className="flex justify-center mb-4">
              <a
                href="https://youtu.be/O73IEaIkVH8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 rounded-full border border-red-500/30 bg-slate-900/80 px-3 py-1.5 text-xs font-semibold text-red-200 shadow-md transition hover:border-red-400 hover:bg-red-950/40 sm:px-4 sm:py-2 sm:text-sm"
              >
                ▶️ Whatch Video GenZUdaan concept video on YouTube
              </a>
            </div>
            <div className="overflow-hidden rounded-2xl border border-fuchsia-500/30 bg-slate-900 shadow-2xl shadow-fuchsia-950/30">
              <img
                src="/assets/GenZUdaanWidescreen.webp"
                alt="GenZUdaan - Give Them Wings"
                className="block h-auto w-full"
                width="1672"
                height="942"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </section>

        {/* Intro */}
        <section className="px-4 py-4 text-center sm:px-6 sm:py-4">
          <div className="mx-auto max-w-3xl">
            <p className="mb-2 text-xs font-bold uppercase tracking-[0.3em] text-fuchsia-400">
              GenZUdaan Flywheel
            </p>

            <h1 className="text-3xl font-black tracking-tight sm:text-5xl">
              Dream. <span className="text-fuchsia-400">Do.</span> Grow.
            </h1>

            <p className="mx-auto mt-4 max-w-2xl text-sm leading-6 text-slate-300 sm:text-base">
              GenZUdaan turns a simple gift into a continuous journey of
              discovery, learning, earning, building and growth.
            </p>
          </div>
        </section>

        {/* Flywheel */}
        <section className="px-4 pb-4 sm:px-6">
          <div className="mx-auto max-w-5xl">
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-7">
              {flywheel.map((item, index) => (
                <React.Fragment key={item.title}>
                  <div className="group relative rounded-2xl border border-white/10 bg-white/[0.04] p-4 text-center transition hover:-translate-y-1 hover:border-fuchsia-400/50 hover:bg-fuchsia-500/10">
                    <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-fuchsia-500/20 to-purple-500/20 text-2xl">
                      {item.icon}
                    </div>

                    <h3 className="text-sm font-black tracking-wide text-white">
                      {item.title}
                    </h3>

                    <p className="mt-1 text-[11px] leading-4 text-slate-400">
                      {item.text}
                    </p>

                    {index < flywheel.length - 1 && (
                      <div className="absolute -right-3 top-1/2 z-10 hidden -translate-y-1/2 text-lg text-fuchsia-400 lg:block">
                        →
                      </div>
                    )}
                  </div>
                </React.Fragment>
              ))}
            </div>

            {/* Repeat indicator */}
            <div className="mt-5 flex items-center justify-center gap-3">
              <div className="h-px flex-1 bg-gradient-to-r from-transparent to-fuchsia-500/50" />
              <div className="rounded-full border border-fuchsia-400/40 bg-fuchsia-500/10 px-4 py-2 text-xs font-bold text-fuchsia-300">
                🔄 REPEAT • REINVEST • RISE
              </div>
              <div className="h-px flex-1 bg-gradient-to-l from-transparent to-fuchsia-500/50" />
            </div>
          </div>
        </section>

        {/* Core Flywheel Message */}
        <section className="px-4 pb-4 sm:px-6">
          <div className="mx-auto max-w-5xl overflow-hidden rounded-3xl border border-fuchsia-500/20 bg-gradient-to-br from-fuchsia-950/40 via-purple-950/30 to-slate-900 p-6 text-center sm:p-10">
            <div className="text-4xl">🪽</div>

            <h2 className="mt-3 text-2xl text-cyan-200 sm:text-4xl">
              One Gift.
              <span className="text-fuchsia-400"> Endless Possibilities.</span>
            </h2>

            <p className="mx-auto mt-4 max-w-2xl text-sm leading-6 text-slate-300 sm:text-base">
              The more you learn, the more you can earn. The more you earn, the
              more you can build. The more you build, the more you can grow —
              and empower others to begin their own journey.
            </p>

            <div className="mt-6 flex flex-wrap justify-center gap-2">
              {["LEARN", "EARN", "BUILD", "SELL", "GROW", "EMPOWER"].map(
                (item) => (
                  <span
                    key={item}
                    className="rounded-full border border-fuchsia-400/30 bg-fuchsia-500/10 px-4 py-2 text-[11px] font-black tracking-wider text-fuchsia-200"
                  >
                    {item}
                  </span>
                ),
              )}
            </div>
          </div>
        </section>

        {/* Modules */}
        <section className="px-4 pb-4 sm:px-6">
          <div className="mx-auto max-w-5xl">
            <div className="mb-5 text-center">
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400">
                What's Inside
              </p>

              <h2 className="mt-2 text-2xl text-cyan-200  sm:text-3xl">
                Your GenZUdaan Toolkit
              </h2>
            </div>

            <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
              {modules.map((module) => (
                <div
                  key={module.name}
                  className="rounded-2xl border border-white/10 bg-slate-900/70 p-4 transition hover:border-fuchsia-400/40 hover:bg-slate-800"
                >
                  <div className="text-2xl">{module.icon}</div>

                  <h3 className="mt-3 text-sm font-bold text-white">
                    {module.name}
                  </h3>

                  <p className="mt-1 text-[11px] leading-4 text-slate-400">
                    {module.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FuelStash */}
        <section className="px-4 pb-4 sm:px-6">
          <div className="mx-auto max-w-5xl rounded-3xl border border-yellow-400/30 bg-gradient-to-r from-yellow-500/10 via-fuchsia-500/10 to-purple-500/10 p-6 text-center sm:p-8">
            <div className="text-3xl">🎁</div>

            <h2 className="mt-3 text-xl text-cyan-200 sm:text-3xl">
              ₹4,999 FuelStash Credit
            </h2>

            <p className="mt-2 text-sm text-slate-300">
              Use your FuelStash Credit to start your digital income journey.
            </p>

            <div className="mt-5 flex flex-col items-center justify-center gap-2 text-xs font-bold sm:flex-row">
              <span className="rounded-full bg-white/10 px-4 py-2">
                🎁 Get Gift from Others
              </span>

              <span className="text-fuchsia-400">+</span>

              <span className="rounded-full bg-white/10 px-4 py-2">
                🚀 Get Gift from Think5Whys
              </span>
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="px-4 pb-6 sm:px-6">
          <div className="mx-auto max-w-4xl text-center">
            <div className="mb-5 text-5xl">🪽</div>

            <h2 className="text-3xl text-cyan-200 sm:text-5xl">
              Give Them Wings.
            </h2>

            <p className="mt-3 text-lg font-semibold text-fuchsia-400">
              Give Them an Opportunity to Fly.
            </p>

            <p className="mx-auto mt-4 max-w-xl text-sm leading-6 text-slate-400">
              Gift GenZUdaan to a young dreamer and help them discover, learn,
              earn, build and grow.
            </p>

            <div className="mt-7 inline-flex rounded-full bg-gradient-to-r from-fuchsia-600 to-purple-600 px-7 py-3 text-sm font-black shadow-lg shadow-fuchsia-900/40">
              🎁 GIFT GENZUdaan
            </div>

            <p className="mt-5 text-[11px] font-bold uppercase tracking-widest text-slate-500">
              Offer for the first 1 lakh gifts
            </p>
          </div>
        </section>

        {/* Footer */}
        <footer className="border-t border-white/10 px-4 py-6 text-center">
          <p className="text-xs font-bold text-slate-400">Think5Whys Global Deeptech Solutions Private Limited. Mumbai. India. A DPIIT Recognised Startup</p>

          <p className="mt-1 text-[10px] text-slate-600">
            Empowering India Digitally
          </p>
        </footer>
      </div>
    </div>
  );
}
